module.exports = __webpack_public_path__ + "img/id-bg.c8001302.png";